export default __webpack_public_path__ + "static/cruiselines-vrc-places-1-37f4966739b0ca07d2547302ee475089.jpg";